export default __webpack_public_path__ + "static/media/get_invited.72c31c4d.png";